import * as React from "react";
import { forwardRef } from "react";
const SvgWoundDistributionNo = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16 5.5c-3.1 5.6-7.5 8.8-7.5 13a7.5 7.5 0 1 0 15 0c0-4.2-4.4-7.4-7.5-13a1 1 0 0 0-1.8 0Z" }), /* @__PURE__ */ React.createElement("path", { d: "M11.5 11.5 20.5 20.5", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", fill: "none" }));
const ForwardRef = forwardRef(SvgWoundDistributionNo);
export default ForwardRef;
